<template>
  <div class="lp-modal-wrapper" style="font-size:12px">
    <div class="columns is-multiline">
      <div class="column is-6" style="border:1px solid #ddd;border-right:0">
        <div class="flex space-between" style="margin-bottom: 24px">
          <div class="flex align-center">
            <span>검색결과</span>
            <span> {{ filteredCount }}</span>
            <span>개 <span style="color:#ccc"> / </span> 전체</span>
            <span> {{ allCount }}</span>
            <span>개</span>
          </div>
          <!-- 10개씩보기 -->
          <div class="control">
            <span class="select">
              <select v-model="filtered.page_length" @change="selPageLength">
                <option v-for="(it,idx) in pageLengthList"
                        :key="'page-'+idx"
                        :value="it.value">{{ it.label }}</option>
              </select>
            </span>
          </div>
        </div>
        <!-- 테이블 -->
        <div class="columns is-multiline">
          <div class="column is-full" style="height: 500px; overflow-y: auto;">
            <table class="table">
              <thead>
              <tr>
                <td>번호</td>
                <td>이미지</td>
                <td>상품명</td>
                <td>판매가</td>
                <td>품절여부</td>
                <td>선택</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(prod,idx) in tableItems" :key="'prod-'+idx">
                <td>{{ prod.id }}</td>
                <td><div style="text-align: center; display: inline-block;"
                         :style="imgField(prod.img)"></div></td>
                <td>{{ prod.name }}</td>
                <td>{{ prod.price.price | currency }}</td>
                <td>
                  <span v-if="prod.soldout">품절</span>
                  <span v-else>판매</span></td>
                <td><button class="button small" :class="{'is-primary':selectedProduct && prod.id === selectedProduct.id}"
                            @click="clickProduct(prod)">선택</button></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 페이지 -->
        <div class="pagination-group">
          <div class="pagination-btn-prev" @click="prevPage">
            <i class="material-icons unselect" style="margin-top:5px">keyboard_arrow_left</i>
          </div>
          <div class="pagination-num"
               v-if="visiblePageNumber(n)"
               v-for="(n,idx) in filtered.total_page"
               :key="'page'+idx">
          <span
            class="unselect"
            :class="{ 'pagination-num-selected' : n === filtered.page_num,
                      'pagination-num-not-selected' : n !== filtered.page_num }"
            @click="changePage(n)" style="font-size:1.2rem">{{ n }}</span>
          </div>
          <div class="pagination-btn-next" @click="nextPage">
            <i class="material-icons unselect" style="margin-top:5px">keyboard_arrow_right</i>
          </div>
        </div>
      </div>
      <!-- 캘린더 -->
      <div class="column is-6" style="height:624px;overflow-y: auto;border:1px solid #dddddd">
        <block-resv-option v-if="selectedProduct"
                    :product="selectedProduct"
                           style="position: relative"
                    @clickReserve="setReserve"></block-resv-option>
      </div>
      <div class="flex justify-center" style="padding: 20px;width:100%">
        <button class="button half" @click="$emit('closeModal')">취소</button>
        <button v-if="resv" class="button is-primary" style="margin-left: 8px;width:unset"
                @click="saveData">{{ resvStr }} 예약하기</button>
      </div>
    </div>
  </div>
</template>

<script>
  import pageLengthStructure from '@/components/module/admin/pageLengthStructure'
  import BlockResv from "./BlockResv";
  import BlockResvOption from "./BlockResvOption";
  export default {
    name: 'reservation-product',
    props: {
      order_conversion_type: {
        type: Number,
        default: 10
      }
    },
    components: {
      BlockResvOption,
      BlockResv
    },
    data() {
      return {
        tableItems: [],
        pageLengthList: pageLengthStructure.common,
        allCount: 0,
        filteredCount: 0,
        filtered: {
          cur_page: 1,
          page_num:1,
          total_page:1,
          page_length: 10
        },
        selectedProduct: undefined,
        visible:false,
        resv: undefined,
        resvStr: ''
      }
    },
    created() {
      this.getProductList();
    },
    methods: {
      setReserve(resv) {
        this.resv = resv;
        this.resvStr = resv.resvStr;
      },
      // 상품 선택
      clickProduct(prod){
        this.selectedProduct = undefined;
        setTimeout(()=>{
          this.selectedProduct = prod;
        },200);
      },
      // 페이지 숫자 보임여부
      visiblePageNumber(n) {
        // 현재 선택된 페이지 + 9까지 보임
        if(this.filtered.page_num <= n && n <= this.filtered.page_num+9) return true;
        // 전체페이지 - 현재 페이지
        let cal_page = this.filtered.total_page - this.filtered.page_num
        if(cal_page < 5 && n >= this.filtered.total_page - 5) {
          return true
        }
        else return false;
      },
      saveData(){
        this.$emit('addProduct', Object.assign(this.selectedProduct, this.resv));
      },
      getProductList(){
        this.$axios.get(this.getUrl('product?order_conversion_type='+this.order_conversion_type), {
          params: this.filtered
        }).then(res=>{
          if(res.status === 200) {
            this.filtered.page_length = res.data.page_length;
            this.filtered.cur_page = res.data.cur_page;
            this.filtered.total_page = res.data.total_page;
            this.allCount = res.data.total_count;
            this.filteredCount = res.data.count;
            this.tableItems = res.data.data;
          }
        })
      },
      selPageLength(){
        this.getProductList();
      },
      changePage(num) {
        this.filtered.page_num = num;
        this.filtered.cur_page = num;
        this.getProductList();
      },
      prevPage() {
        if (this.filtered.page_num > 1) {
          this.filtered.page_num -= 1;
          this.getProductList();
        }
      },
      nextPage() {
        if (this.filtered.page_num < this.filtered.total_page) {
          this.filtered.page_num += 1;
          this.getProductList();
        }
      },
      clickOutSide(){
        this.visible = false;
      },
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 60px; height: 60px; background-size: cover;' +
          ' background-position: center;';
      },
      //상품 선택
      selectProduct() {

      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
  .pagination-group {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }

  .pagination-btn-prev
  .pagination-btn-next {
    display: inline-block;
  }

  .pagination-num {
    display: inline-block;
  }

  .pagination-btn-prev i
  .pagination-btn-next i {
    color: #18a4ed;
    margin: 4px;
    cursor: pointer;
  }

  .pagination-num {
    padding: 5px 8px;
    cursor: pointer;
    font-size: .9rem;
  }

  .pagination-num-selected {
    color: #18a4ed;
  }

  .pagination-num-not-selected {
    color: #666;
  }
</style>
